import {
  BriefcaseBusinessIcon,
  EllipsisIcon,
  MailIcon,
  UserIcon,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export const AccountSettingsAdminTable = ({
  admins,
}: {
  admins: { email: string; name: string }[];
}) => {
  return (
    <div className="flex flex-col overflow-auto">
      <div className="rounded-t-lg border border-b-0 border-slate-200">
        <Table>
          <TableHeader>
            <TableRow className="border-none">
              <TableHead className="w-[25%]">
                <div className="flex items-center gap-1">
                  <UserIcon className="h-4 w-4 text-slate-700" />
                  <p className="font-semibold text-slate-700">Name</p>
                </div>
              </TableHead>
              <TableHead className="w-[33%]">
                <div className="flex items-center gap-1">
                  <MailIcon className="h-4 w-4 text-slate-700" />
                  <p className="font-semibold text-slate-700">Email</p>
                </div>
              </TableHead>
              <TableHead className="w-[34%]">
                <div className="flex items-center gap-1">
                  <BriefcaseBusinessIcon className="h-4 w-4 text-slate-700" />
                  <p className="font-semibold text-slate-700">Role</p>
                </div>
              </TableHead>
              <TableHead className="w-[8%]" />
            </TableRow>
          </TableHeader>
        </Table>
      </div>
      <div className="overflow-y-auto rounded-b-lg border border-slate-200">
        <Table>
          <TableBody>
            {admins.map(({ name, email }) => (
              <TableRow key={name}>
                <TableCell className="w-[25%]">
                  <p className="font-medium text-slate-700">{name}</p>
                </TableCell>
                <TableCell className="w-[33%]">
                  <p className="font-medium text-slate-700">{email}</p>
                </TableCell>
                <TableCell className="w-[34%]">
                  <p className="font-medium text-slate-700">Admin</p>
                </TableCell>
                <TableCell className="w-[8%]">
                  <Button disabled size="icon" variant="ghost">
                    <EllipsisIcon className="h-4 w-4" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
